/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTION_TYPES_RECEIVE]: (state, action) => {

            return reduce(
                action.payload.connectionTypes,
                (memo, connectionTypes) => {
                    const { id } = connectionTypes;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = connectionTypes;
                    return memo;
                },
                state,
            );
        }
    },
);